// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'records'

/**
 * Record Model Interface (auto-generated from Drizzle schema)
 */
export interface RecordModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  schemaId: string
  title: string
  status: string
  parentId: string
  parentCollection?: string
  data: Record<string, unknown>
  archived: boolean
  completed?: boolean
  completedAt?: string
  startedAt?: string
  sortOrder?: number
  assigneeId: string
  priority?: number
  dueAt?: string
  amount?: number
  version: number
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "schemaId": {
          "type": "string",
          "maxLength": 100
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "status": {
          "type": "string",
          "maxLength": 50
      },
      "parentId": {
          "type": "string",
          "maxLength": 100
      },
      "parentCollection": {
          "type": "string",
          "maxLength": 200
      },
      "data": {
          "type": "object"
      },
      "archived": {
          "type": "boolean"
      },
      "completed": {
          "type": "boolean"
      },
      "completedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "startedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "sortOrder": {
          "type": "integer",
          "minimum": 0,
          "maximum": 999999,
          "multipleOf": 1
      },
      "assigneeId": {
          "type": "string",
          "maxLength": 100
      },
      "priority": {
          "type": "integer",
          "minimum": 0,
          "maximum": 4,
          "multipleOf": 1
      },
      "dueAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "amount": {
          "type": "number",
          "minimum": -999999999,
          "maximum": 999999999,
          "multipleOf": 0.01
      },
      "version": {
          "type": "integer",
          "minimum": 1,
          "maximum": 9999999,
          "multipleOf": 1
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "schemaId",
      "title",
      "data",
      "archived",
      "version",
      "status",
      "parentId",
      "workspaceId",
      "assigneeId"
  ],
  indexes: [
      [
          "schemaId",
          "orgId"
      ],
      [
          "schemaId",
          "orgId",
          "status"
      ],
      [
          "parentId"
      ],
      [
          "schemaId",
          "orgId",
          "updatedAt"
      ],
      [
          "orgId",
          "createdAt"
      ],
      [
          "orgId",
          "workspaceId",
          "createdAt"
      ],
      [
          "orgId",
          "assigneeId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
